const gradients = {
  patientDetailsPageContainer: "linear-gradient(#faf9f2, #faf3f0, #cdd4cc)",
  patientDetailsPageNavigation: "linear-gradient(#faf9f2, #faf3f0, #cdd4cc)",
  createPatientPageContainer: "linear-gradient(#faf9f2, #faf3f0, #cdd4cc)",
};

export default gradients;
